import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@eb/antd';
import Text from '@eb/antd/lib/typography/Text';
import { I18N } from 'commons';

const UpLogin = ({ publicPortalURL }) => {

  const handleRedirect = () => {
    window.location.assign(publicPortalURL);
  };

  return (
    <div className="login-form-box access-account-form">
      <div className="row login-form-title">
        <h1 className="col-12 text-center">
          <I18N>access.account.title</I18N>
        </h1>
      </div>
      <div className="row access-form-item">
        <Text className="col-12 text-center">
          <I18N>access.account.subtext</I18N>
        </Text>
      </div>
      <div className="row access-button-box">
        <Button
          className="btn btn-primary btn-block"
          type="button"
          onClick={handleRedirect}
          eb-test="ssp_login_button_submit"
          target="_blank"
        >
          <I18N>access.account.continue</I18N>
        </Button>
      </div>
    </div>
  );
};

UpLogin.propTypes = {
  publicPortalURL: PropTypes.string.isRequired,
  orgId: PropTypes.string.isRequired,
  showSignUp: PropTypes.bool.isRequired,
  enabledSSO: PropTypes.bool.isRequired,
};

export default UpLogin;
